import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import ViewBranchDetails from "./ViewBranchDetails";

// Component for rendering view branch details page 
const ViewBranchDetailsMain = () => {
  const { t } = useTranslation(); // Initialize translation hook

  useEffect(() => {
    GridStack.init(); // Initialize GridStack layout system
  }, []);

  // Define grid layout configuration with header and content components
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader title={t("branch_details")} showIconsForback={true} />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 1,
      component: <ViewBranchDetails />,
    },
  ];

  // Render grid container with layout items
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ViewBranchDetailsMain;
